import { useEffect, useState } from 'react';
import { clearMeasureCache } from '../lib/textLayout';

let version = 0;
const listeners = new Set();
if (typeof document !== 'undefined' && document.fonts && document.fonts.addEventListener) {
  document.fonts.addEventListener('loadingdone', () => {
    version += 1;
    clearMeasureCache();
    listeners.forEach((l) => l(version));
  });
}

/** Re-renders when web fonts finish loading so canvas text measurements stay accurate. */
export const useFontsVersion = () => {
  const [v, setV] = useState(version);
  useEffect(() => { listeners.add(setV); return () => listeners.delete(setV); }, []);
  return v;
};
